import { render } from "./Prints.vue?vue&type=template&id=2836ea58&scoped=true"
import script from "./Prints.vue?vue&type=script&lang=js"
export * from "./Prints.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2836ea58"

export default script